function TadaImage() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="160"
      height="160"
      fill="none"
      viewBox="0 0 160 160"
    >
      <path
        fill="#D9E7FE"
        d="M121.49 36.291c17.444 15.233 19.222 26.347 19.343 41.158-2.771 31.152-22.065 79.092-71.18 64.813-61.394-17.849-55.226-68.825-43.247-84.714C47.212 29.95 93.225 11.61 121.49 36.291z"
      ></path>
      <mask
        id="mask0_592_3280"
        style={{ maskType: 'alpha' }}
        width="90"
        height="86"
        x="15"
        y="59"
        maskUnits="userSpaceOnUse"
      >
        <path
          fill="#F7C14E"
          d="M47.657 62.642l-31.905 75.511c-1.544 3.653 2.034 7.38 5.747 5.987l80.384-30.161c3.136-1.177 3.945-5.239 1.499-7.527l-48.479-45.35c-2.294-2.146-6.023-1.353-7.246 1.54z"
        ></path>
      </mask>
      <g mask="url(#mask0_592_3280)">
        <path
          fill="#FFCC60"
          d="M16.971 54.943H113.528V152.459H16.971z"
          transform="rotate(3.27 16.97 54.943)"
        ></path>
        <path
          fill="#F39D4D"
          d="M94.295 109.32l-81.088 33.898 4.23 4.944 92.845-33.681-15.987-5.161z"
        ></path>
        <path
          fill="#FA5C86"
          d="M14.07 123.387c31.034 1.973 48.691 1.278 80.296-3.603l-5.648 12.092c-30.047 4.264-46.726 4.473-76.265 2.124l1.617-10.613z"
        ></path>
        <path
          fill="#D32252"
          d="M58.024 123.9l-25.636 11.506 20.588 1.176 33.526-15.057-28.478 2.375z"
        ></path>
        <path
          fill="#FA5C86"
          d="M22.55 101.047c29.424 1.693 46.18.842 76.2-4.315l-5.452 12.126c-28.537 4.527-44.361 4.885-72.365 2.803l1.616-10.614zM29.114 78.666c29.544 1.713 46.366.873 76.502-4.263l-5.466 12.123c-28.649 4.508-44.536 4.855-72.652 2.754l1.616-10.614z"
        ></path>
      </g>
      <path
        fill="#FEF7E7"
        d="M37.641 99.524l5.09-9.677a2.895 2.895 0 012.564-1.546c2.19.001 3.584 2.34 2.546 4.267l-5.187 9.625a2.839 2.839 0 01-2.799 1.476c-1.995-.211-3.148-2.369-2.214-4.145z"
      ></path>
      <ellipse
        cx="77.514"
        cy="86.066"
        fill="#003DA1"
        rx="7.777"
        ry="38.531"
        transform="rotate(-46.244 77.514 86.066)"
      ></ellipse>
      <path
        fill="#002560"
        d="M82.892 80.448s27.807 27.217 22.511 32.549c-5.267 5.304-33.267-21.315-33.267-21.315s5.831 2.28 10.082.576c3.626-1.453.674-11.81.674-11.81z"
      ></path>
      <ellipse
        cx="49.373"
        cy="81.696"
        fill="#FEF7E7"
        rx="3.037"
        ry="3.037"
        transform="rotate(3.27 49.373 81.696)"
      ></ellipse>
      <path
        stroke="#FB517E"
        strokeLinecap="square"
        strokeWidth="2.839"
        d="M66.755 71.22s8.71-30.854-12.424-39.977"
      ></path>
      <path
        stroke="#FD9FB8"
        strokeLinecap="square"
        strokeWidth="2.839"
        d="M104.999 56.796c12.915-15.673 21.356-22.798 38.935-32.017"
      ></path>
      <path
        stroke="#70A7FF"
        strokeLinecap="square"
        strokeWidth="2.839"
        d="M83.996 65.708c9.999-18.825 13.815-37.163 7.737-58.595M98.704 102.638c10.021-2.087 26.068-2.32 34.024 15.212"
      ></path>
      <path
        stroke="#FB658D"
        strokeLinecap="square"
        strokeWidth="2.839"
        d="M106.235 81.966c15.588-13.922 44.268.209 32.433 10.365-9.954 8.542-16.751-6.331-10.3-15.22 1.859-2.56 6.532-4.45 6.532-4.45 6.342-3.252 17.735-1.566 20.157 8.65"
      ></path>
      <path
        fill="#1D74F5"
        d="M67.43 21.972a3.368 3.368 0 11.555-6.713 3.368 3.368 0 01-.555 6.713zM132.619 59.813l-.299-3.52a.79.79 0 00-.861-.724l-9.156.782a.79.79 0 00-.724.862l.299 3.52a.79.79 0 00.861.724l9.156-.782a.798.798 0 00.724-.862z"
      ></path>
      <path
        fill="#FFCC60"
        d="M89.156 81.607l-3.348-.335a.763.763 0 00-.833.68l-.875 8.703a.763.763 0 00.678.833l3.348.335c.42.04.791-.265.833-.679l.876-8.704a.754.754 0 00-.68-.833z"
      ></path>
      <path
        fill="#FB658D"
        d="M98.193 72.3a3.146 3.146 0 11.517-6.271 3.146 3.146 0 01-.517 6.27z"
      ></path>
      <path
        fill="#83B2FE"
        d="M109.691 32.098a3.303 3.303 0 11.544-6.584 3.303 3.303 0 01-.544 6.584z"
      ></path>
      <path
        fill="#FFCC60"
        d="M144.758 46.51l-1.265-6.479a.759.759 0 00-1.252-.42l-5.826 5.24a.758.758 0 00.374 1.312l7.086 1.239a.76.76 0 00.883-.892z"
      ></path>
      <path
        fill="#83B2FE"
        d="M40.745 50.919l2.362-2.395a.753.753 0 00-.009-1.072l-6.232-6.143a.752.752 0 00-1.072.008l-2.363 2.395a.753.753 0 00.01 1.072l6.232 6.144a.761.761 0 001.072-.009zM110.669 123.81a2.997 2.997 0 11.493-5.973 2.997 2.997 0 01-.493 5.973z"
      ></path>
    </svg>
  );
}

export default TadaImage;
